import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=5735f204&scoped=true&lang=html&"
import script from "./ProjectDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectDetail.vue?vue&type=script&lang=js&"
import style1 from "./ProjectDetail.vue?vue&type=style&index=1&id=5735f204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5735f204",
  null
  
)

export default component.exports